// ════ FILE: src/theme/theme.js ════

const BASE_THEME = {
  appName: "RechargeCircle",
  appVersion: "1.0.0",
  businessName: "PAYGROWTH SOLUTION PVT LTD",
  businessAddress: "Kopatigaon, Silbori, Darrang, Orang, Assam, India, 784114",
  slogan: "Fast, Secure & Easy Recharges",
  cin: "U62099AS2026PTC029665",
  primaryColor: "#6C63FF",
  primaryDark: "#574FD6",
  primaryLight: "var(--primary-light, #EAE8FF)",
  accentColor: "#FF6B6B",
  textOnPrimary: "#FFFFFF",
  bgColor: "var(--bg-color, #FFFFFF)",
  surfaceColor: "var(--surface-color, #F8F8FC)",
  textPrimary: "var(--text-primary, #1A1A2E)",
  textSecondary: "var(--text-secondary, #6B7280)",
  borderColor: "var(--border-color, #E5E7EB)",
  successColor: "#22C55E",
  errorColor: "#EF4444",
  warningColor: "#F59E0B",
  fontFamily: "'Poppins', sans-serif",
  borderRadiusBtn: "12px",
  borderRadiusCard: "16px",
  borderRadiusInput: "10px",
  playStoreURL: 'https://play.google.com/store/apps/details?id=in.recharge.circle&hl=en_IN',
  appStoreURL: 'https://play.google.com/store/apps/details?id=in.recharge.circle&hl=en_IN',
  support: {
    callSupport: '+919282289163',
    emailSupport: 'support@rechargecircle.in',
    whatsAppSupport: 'https://wa.me/919282289163',
    liveSupport: ''
  },
  socialLinks: {
    whatsapp: "https://wa.me/919282289163",
    facebook: "https://www.instagram.com/rechargecircle.in?igsh=MW9qeWpkYXZ5eHBueA==",
    instagram: "https://www.instagram.com/rechargecircle.in?igsh=MW9qeWpkYXZ5eHBueA==",
    youtube: "https://youtube.com/@rechargecircle?si=3Bd9eV0X45pyDGch",
  },
  policyUrls: {
    terms: "https://rechargecircle.in/policy.html?tab=terms",
    privacy: "https://rechargecircle.in/policy.html?tab=privacy",
    refund: "https://rechargecircle.in/policy.html?tab=refund",
    cancellation: "https://rechargecircle.in/policy.html?tab=cancellation",
    accountDeletion: "https://rechargecircle.in/policy.html?tab=deletion",
  },
};

export const PRESETS = {
  rechargecircle: {
    primaryColor: "#323DB8",
    primaryDark: "#323DB8",
    primaryLight: "#bec2ed",
    accentColor: "#F59E0B",
  },
  oceanBlue: {
    primaryColor: "#2563EB",
    primaryDark: "#1D4ED8",
    primaryLight: "#DBEAFE",
    accentColor: "#F97316",
  },
  royalPurple: {
    primaryColor: "#2f31ee",
    primaryDark: "#2f31ee",
    primaryLight: "#EDE9FE",
    accentColor: "#EC4899",
  },
  emeraldGreen: {
    primaryColor: "#059669",
    primaryDark: "#047857",
    primaryLight: "#D1FAE5",
    accentColor: "#F59E0B",
  },
  roseGold: {
    primaryColor: "#E11D48",
    primaryDark: "#BE123C",
    primaryLight: "#FFE4E6",
    accentColor: "#F59E0B",
  },
  midnightSlate: {
    primaryColor: "#0F172A",
    primaryDark: "#020617",
    primaryLight: "#E2E8F0",
    accentColor: "#38BDF8",
  },
  sunsetOrange: {
    primaryColor: "#EA580C",
    primaryDark: "#C2410C",
    primaryLight: "#FED7AA",
    accentColor: "#7C3AED",
  },
  skyCyan: {
    primaryColor: "#0891B2",
    primaryDark: "#0E7490",
    primaryLight: "#CFFAFE",
    accentColor: "#F97316",
  },
  forestDeep: {
    primaryColor: "#15803D",
    primaryDark: "#166534",
    primaryLight: "#DCFCE7",
    accentColor: "#EF4444",
  },
  indigoNight: {
    primaryColor: "#4338CA",
    primaryDark: "#3730A3",
    primaryLight: "#E0E7FF",
    accentColor: "#10B981",
  },
  warmAmber: {
    primaryColor: "#B45309",
    primaryDark: "#92400E",
    primaryLight: "#FEF3C7",
    accentColor: "#6C63FF",
  },
};

export const ACTIVE_PRESET = PRESETS.rechargecircle;
export const APP_THEME = { ...BASE_THEME, ...ACTIVE_PRESET };
